export default {
  offers: {
    greenerEnergyOffer: 'greener-energy-offer',
    greenerElectricityOffer: 'greener-electricity-offer',
  },
};
